import { render } from "./MWOrganiserLogos.vue?vue&type=template&id=6a76c76e"
import script from "./MWOrganiserLogos.vue?vue&type=script&lang=js"
export * from "./MWOrganiserLogos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__